import type { ReactNode } from "react";

interface HeaderProps {
  leftSection: ReactNode;
  rightSection?: ReactNode;
}

export const Header = ({ leftSection, rightSection }: HeaderProps) => {
  return (
    <div className="flex flex-row items-center justify-between border-b-1 border-[#eeeff1] px-4 py-2">
      {leftSection}
      {rightSection ?? <></>}
    </div>
  );
};
